import type { RecurringFrequency } from './types';

export const RECURRING_FREQUENCIES: readonly { value: RecurringFrequency; label: string }[] = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'yearly', label: 'Yearly' },
];

const FREQ_LABEL: Record<RecurringFrequency, string> = {
  weekly: 'Weekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
};

export const frequencyLabel = (f: RecurringFrequency): string => FREQ_LABEL[f] ?? f;

/** Expense categories (mirrors finance ExpenseCategory). */
export const EXPENSE_CATEGORIES: readonly { value: string; label: string }[] = [
  { value: 'software', label: 'Software / SaaS' },
  { value: 'contractor', label: 'Contractor' },
  { value: 'office', label: 'Office' },
  { value: 'payroll', label: 'Payroll' },
  { value: 'tax', label: 'Tax' },
  { value: 'other', label: 'Other' },
];

const CATEGORY_LABEL = Object.fromEntries(EXPENSE_CATEGORIES.map((c) => [c.value, c.label]));
export const categoryLabel = (c: string): string => CATEGORY_LABEL[c] ?? c;
